
export interface ContentsProps {
  children?: React.ReactNode
}

export function Contents(props: ContentsProps) {
  return <div className="pcy-contents">{props.children}</div>
}
